export default __webpack_public_path__ + "static/media/lato-italic.d1a09f10.ttf";